export default function DiscordIcon({ width = 22, height = 16, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 42 31"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M35.895 3.77841C35.895 3.77841 31.564 0.389136 26.4489 0L25.9878 0.921773C30.6126 2.05355 32.7342 3.67532 34.95 5.66746C31.129 3.717 27.3563 1.88905 20.7811 1.88905C14.2059 1.88905 10.4329 3.717 6.61214 5.66746C8.82827 3.67532 11.3521 1.87473 15.5744 0.921773L15.1133 0C9.7475 0.507182 5.66777 3.77841 5.66777 3.77841C5.66777 3.77841 0.830455 10.7921 0 24.5598C4.87614 30.1827 12.2799 30.2273 12.2799 30.2273L13.8282 28.1632C11.2003 27.2497 8.23232 25.6184 5.66777 22.6705C8.72645 24.9846 13.3426 27.3935 20.7814 27.3935C28.2202 27.3935 32.8364 24.9849 35.895 22.6705C33.3305 25.6184 30.3625 27.25 27.7346 28.1632L29.2829 30.2273C29.2829 30.2273 36.6867 30.1827 41.5628 24.5595C40.7324 10.7921 35.895 3.77841 35.895 3.77841ZM14.6415 20.7814C12.8154 20.7814 11.3352 19.0896 11.3352 17.003C11.3352 14.9164 12.8154 13.2246 14.6415 13.2246C16.4675 13.2246 17.9477 14.9164 17.9477 17.003C17.9477 19.0896 16.4675 20.7814 14.6415 20.7814ZM26.9214 20.7814C25.0953 20.7814 23.6151 19.0896 23.6151 17.003C23.6151 14.9164 25.0953 13.2246 26.9214 13.2246C28.7474 13.2246 30.2276 14.9164 30.2276 17.003C30.2276 19.0896 28.7471 20.7814 26.9214 20.7814Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
